import React from 'react';
import { BaseRow } from '../shared/BaseRow';
import { MentionText } from '../shared';
import { Title, Meta, Comment, DateText, Header } from './styles';
import { theme } from 'src/Utils';
import dayjs from 'dayjs';
var typeLabel = {
    claim: 'Reclamo',
    budget_request: 'Presupuesto',
    payment_authorization: 'Autorización de Pago',
    comment: 'Comentario',
};
var getLeftBarColor = function (variant) {
    switch (variant) {
        case 'payment_authorization':
            return theme.palette.green;
        case 'claim':
            return theme.palette.red;
        case 'budget_request':
            return theme.palette.yellow;
        case 'comment':
        default:
            return '#6F98C9';
    }
};
var ArrangementRow = function (_a) {
    var data = _a.data, _b = _a.validMentions, validMentions = _b === void 0 ? [] : _b;
    var formattedDate = dayjs(data.created_at).fromNow();
    var header = (React.createElement(Header, null,
        React.createElement(Title, null,
            typeLabel[data.arrangement_type],
            " | Admin - ",
            data.created_by_name),
        React.createElement(DateText, null, formattedDate)));
    var content = (React.createElement(React.Fragment, null,
        data.provider_name && React.createElement(Meta, null,
            "Proveedor: ",
            data.provider_name),
        data.authorized_by_name && (React.createElement(Meta, null,
            "Autorizado por: ",
            data.authorized_by_name)),
        data.internal_comment && (React.createElement(Comment, null,
            React.createElement(MentionText, { text: data.internal_comment, validMentions: validMentions })))));
    return (React.createElement(BaseRow, { leftBarColor: getLeftBarColor(data.arrangement_type), leftBarWidth: 4, leftBarBorderRadius: 24, header: header, content: content, files: data.files, containerStyle: {
            display: 'grid',
            gridTemplateColumns: '6px 1fr',
            gap: '12px',
            marginBottom: 0,
            padding: '8px 10px',
            borderRadius: '10px',
        }, contentStyle: { gap: '6px' }, filesContainerStyle: { gap: '16px', marginTop: '8px' }, fileThumbStyle: { borderRadius: '2px' } }));
};
export default ArrangementRow;
